import { FC, useEffect, useState } from "react";
import {
  useAppDispatch,
  useAppSelector,
} from "../../redux-store/CustomReduxHooks";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getDecryptedSearchParamsValue } from "../../axios/axiosEncryptionUtils";
import {
  setLongSessionAuthToken,
  updateChannelDetails,
  updateTraceId,
} from "../../redux-store/reducers/CsAppSlice";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import CsSessionStorageUtils from "../../utils/CsSessionStorageUtils";
import { updateLoadingState } from "../Feature_Loading/Loading_Slice";
import NotFound from "../../pages/NotFound/NotFound";
import { isEmpty } from "lodash";
// import dayjs from "dayjs";
import { updatePseudoLoginState } from "./PseudoLogin_Slice";
import { updateLoginData } from "../Feature_Login/Login_Slice";

const Feature_PseudoLogin: FC = () => {
  const [urlSearchParam] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isError, setIsError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<any>("");
  const { tokenDetails } = useAppSelector((state) => state.CsAppSlice);

  const handlePseudoLoginWithConfig = (configurationData: any) => {
    const request = urlSearchParam.get("request") || "";
    const authToken = urlSearchParam.get("authToken") || "";
    const traceId = urlSearchParam.get("traceId") || "";
    if (traceId) {
      dispatch(updateTraceId(traceId));
      CsSessionStorageUtils.set("TRACE_ID", traceId);
    }
    if (request.length === 0 || !request) {
      dispatch(updateLoadingState(false));
      setIsError(true);
      return;
    }
    let requestData: any = getDecryptedSearchParamsValue(
      request,
      configurationData,
    );
    if (requestData?.source === "pseudoLogin") {
      // let diff = dayjs().diff(dayjs(requestData?.createdAt), "minute");
      // if (diff >= Number(requestData.expireInMinutes)) {
      //   dispatch(updateLoadingState(false));
      //   setIsError(true);
      //   return;
      // }
    }
    dispatch(setLongSessionAuthToken(authToken));
    dispatch(
      updateLoginData({ key: "mobilenumber", value: requestData.mobileNo }),
    );
    dispatch(updateChannelDetails(E_ChannelOptions.CSAPP));
    CsSessionStorageUtils.set("LOGGED_IN_TIME", new Date().toISOString());
    dispatch(updateLoginData({ key: "isUserLoggedIn", value: true }));

    dispatch(
      updatePseudoLoginState({
        isPseudoLoggedIn: true,
        source: requestData?.source,
        mobileNumber: requestData?.mobileNo,
        createdAt: requestData?.createdAt,
        expireInMinutes: Number(requestData?.expireInMinutes),
        adminIdFromPseudo: requestData?.adminId,
      }),
    );
    if (!isEmpty(requestData.mobileNo)) {
      dispatch(updateLoadingState(true));
    }
    navigate("/home", { replace: true });
  };

  useEffect(() => {
    try {
      if (tokenDetails?.configuration?.iv) {
        try {
          handlePseudoLoginWithConfig(tokenDetails?.configuration);
        } catch (error) {
          console.error(
            "Error validating pseudo login response with configuration",
            error,
          );
        }
      } else {
        dispatch(updateLoadingState(true));
      }
    } catch (e: any) {
      console.error(e);
      dispatch(updateLoadingState(false));
      setErrorMessage(e);
      setIsError(true);
      return;
    }
  }, [tokenDetails?.configuration]);

  return isError ? (
    <NotFound
      hideButton={true}
      moduleName="Feature_PseudoLogin"
      pageName="Feature_PseudoLogin"
      errorTitle=""
      errorMessage={errorMessage}
    />
  ) : (
    <></>
  );
};
export default Feature_PseudoLogin;
